import { icon, throttle } from './lib/common.js'

const menu = document.querySelector('nav.m-menu-fast')
const mouseEnterHandler = () => menu.classList.add('is-open')
const mouseLeaveHandler = () => menu.classList.remove('is-open')
const mouseClickHandler = () => menu.classList.toggle('is-open')

let currentMode = ''
let removeDesktopListeners = false
let removeMobileListeners = false

if (menu) {
  if(document.body.classList.contains('p-formation_continue') || document.body.classList.contains('p-formation_initiale')) {
    menu.style.display = 'none'
  } else {
    const links = menu.querySelectorAll('a')
    const length = links.length
    for (const [index, link] of links.entries()) {
      const iconName = link.className !== '' ? link.className : 'logo'
      link.innerHTML =
        `<span class="icon">${icon(iconName)}</span><span class="text">${link.textContent}</span>`
      const text = link.querySelector('.text')
      link.style.setProperty('--index', length - index)
      link.style.setProperty('--text-width', `${text.offsetWidth}px`)
    }
  }
}

function desktop() {
  if (removeMobileListeners) {
    menu.removeEventListener('click', mouseClickHandler)
  }

  menu.addEventListener('mouseenter', mouseEnterHandler)
  menu.addEventListener('mouseleave', mouseLeaveHandler)
  removeDesktopListeners = true
}

function mobile() {
  if (removeDesktopListeners) {
    menu.removeEventListener('mouseenter', mouseEnterHandler)
    menu.removeEventListener('mouseleave', mouseLeaveHandler)
  }

  menu.addEventListener('click', mouseClickHandler)
  removeMobileListeners = true
}

function resize() {
  if (menu) {
    if (window.matchMedia('(min-width:768px)').matches) {
      if (currentMode !== 'desktop') {
        currentMode = 'desktop'
        console.log('desktop')
        desktop()
      }
    } else {
      if (currentMode !== 'mobile') {
        currentMode = 'mobile'
        console.log('mobile')
        mobile()
      }
    }
  }
}

window.addEventListener('resize', throttle(resize, 50), false)
resize()
